import { useEffect, useRef, useState } from 'react';
import { API, TagsAPI } from '@brg/api';
import urlApi from 'shared/actions/urlApi';

const EMPTY: any[] = [];

type CacheEntry = {
    raw: unknown;
    translated: Map<string, any[]>;
};

const tagsTreeCache = new Map<string, CacheEntry>();
const tagsTreeInflight = new Map<string, Promise<unknown>>();

const createRequestKey = (filter: unknown, appContext?: string) =>
    JSON.stringify({ filter, appContext: appContext ?? '' });

const UI_TAG_LIMIT = 80;

const trimTreeForUi = (raw: unknown): unknown => {
    if (!Array.isArray(raw)) return raw;
    return raw.map((node: any) => {
        const kids = node?.additionalTags;
        if (!Array.isArray(kids) || kids.length <= UI_TAG_LIMIT) {
            return node;
        }
        return {
            ...node,
            additionalTags: kids.slice(0, UI_TAG_LIMIT),
            isShowAll: true,
        };
    });
};

const getTranslated = (entry: CacheEntry, lang: string): any[] => {
    const cached = entry.translated.get(lang);
    if (cached) return cached;

    const next = API.toLang(trimTreeForUi(entry.raw), lang) as any[];
    const normalized = Array.isArray(next) && next.length ? next : EMPTY;
    entry.translated.set(lang, normalized);
    return normalized;
};

const fetchTagsTree = (filter: any, appContext?: string): Promise<unknown> => {
    const key = createRequestKey(filter, appContext);
    const cached = tagsTreeCache.get(key);

    if (cached) {
        return Promise.resolve(cached.raw);
    }

    const inflight = tagsTreeInflight.get(key);
    if (inflight) {
        return inflight;
    }

    const request: Promise<unknown> = appContext
        ? Promise.resolve(urlApi()?.fetchTagsTree(filter, appContext)).then((res: any) =>
              Array.isArray(res?.data) ? res.data : []
          )
        : TagsAPI.GetTagsTree(filter)
              .then((value) => value.json())
              .then((value) => (Array.isArray(value) ? value : []));

    const promise = request
        .then((data) => {
            tagsTreeCache.set(key, { raw: data, translated: new Map() });
            return data;
        })
        .finally(() => {
            tagsTreeInflight.delete(key);
        });

    tagsTreeInflight.set(key, promise);
    return promise;
};

export const useGetApiTags = (
    filter: any,
    lang = 'en',
    _t?: number,
    disabled?: boolean,
    appContext?: string
): [any[], boolean, string | undefined] => {
    const [data, setData] = useState<any[]>(EMPTY);
    const [isLoading, setIsLoading] = useState<boolean>(!disabled);
    const [error, setError] = useState<string>();

    const requestKey = createRequestKey(filter, appContext);
    const localizedKey = JSON.stringify([requestKey, lang]);
    const filterRef = useRef(filter);
    filterRef.current = filter;
    const appliedKeyRef = useRef<string>();

    useEffect(() => {
        if (disabled) {
            setIsLoading((prev) => (prev ? false : prev));
            return;
        }

        if (appliedKeyRef.current === localizedKey) {
            setIsLoading((prev) => (prev ? false : prev));
            return;
        }

        let cancelled = false;
        let rafId = 0;

        const apply = (entry: CacheEntry) => {
            if (cancelled) return;
            // Defer heavy toLang off the hover/mousemove frame
            rafId = window.requestAnimationFrame(() => {
                if (cancelled) return;
                setData(getTranslated(entry, lang));
                appliedKeyRef.current = localizedKey;
                setError(undefined);
                setIsLoading(false);
            });
        };

        const cached = tagsTreeCache.get(requestKey);
        if (cached) {
            apply(cached);
            return () => {
                cancelled = true;
                window.cancelAnimationFrame(rafId);
            };
        }

        setIsLoading(true);
        setError(undefined);

        fetchTagsTree(filterRef.current, appContext)
            .then(() => {
                if (cancelled) return;
                const entry = tagsTreeCache.get(requestKey);
                if (!entry) return;
                apply(entry);
            })
            .catch((reason) => {
                if (cancelled) return;
                setError(reason);
                setIsLoading(false);
            });

        return () => {
            cancelled = true;
            window.cancelAnimationFrame(rafId);
        };
    }, [disabled, requestKey, appContext, lang, localizedKey]);

    return [data, isLoading, error];
};
import { useEffect, useRef, useState } from 'react';
import { API, TagsAPI } from '@brg/api';
import urlApi from 'shared/actions/urlApi';

const EMPTY: any[] = [];

type CacheEntry = {
    raw: unknown;
    translated: Map<string, any[]>;
};

const tagsTreeCache = new Map<string, CacheEntry>();
const tagsTreeInflight = new Map<string, Promise<unknown>>();

const createRequestKey = (filter: unknown, appContext?: string) =>
    JSON.stringify({ filter, appContext: appContext ?? '' });

const UI_TAG_LIMIT = 80;

const trimTreeForUi = (raw: unknown): unknown => {
    if (!Array.isArray(raw)) return raw;
    return raw.map((node: any) => {
        const kids = node?.additionalTags;
        if (!Array.isArray(kids) || kids.length <= UI_TAG_LIMIT) {
            return node;
        }
        return {
            ...node,
            additionalTags: kids.slice(0, UI_TAG_LIMIT),
            isShowAll: true,
        };
    });
};

const getTranslated = (entry: CacheEntry, lang: string): any[] => {
    const cached = entry.translated.get(lang);
    if (cached) return cached;

    const next = API.toLang(trimTreeForUi(entry.raw), lang) as any[];
    const normalized = Array.isArray(next) && next.length ? next : EMPTY;
    entry.translated.set(lang, normalized);
    return normalized;
};

const fetchTagsTree = (filter: any, appContext?: string): Promise<unknown> => {
    const key = createRequestKey(filter, appContext);
    const cached = tagsTreeCache.get(key);

    if (cached) {
        return Promise.resolve(cached.raw);
    }

    const inflight = tagsTreeInflight.get(key);
    if (inflight) {
        return inflight;
    }

    const request: Promise<unknown> = appContext
        ? Promise.resolve(urlApi()?.fetchTagsTree(filter, appContext)).then((res: any) =>
              Array.isArray(res?.data) ? res.data : []
          )
        : TagsAPI.GetTagsTree(filter)
              .then((value) => value.json())
              .then((value) => (Array.isArray(value) ? value : []));

    const promise = request
        .then((data) => {
            tagsTreeCache.set(key, { raw: data, translated: new Map() });
            return data;
        })
        .finally(() => {
            tagsTreeInflight.delete(key);
        });

    tagsTreeInflight.set(key, promise);
    return promise;
};

export const useGetApiTags = (
    filter: any,
    lang = 'en',
    _t?: number,
    disabled?: boolean,
    appContext?: string
): [any[], boolean, string | undefined] => {
    const [data, setData] = useState<any[]>(EMPTY);
    const [isLoading, setIsLoading] = useState<boolean>(!disabled);
    const [error, setError] = useState<string>();

    const requestKey = createRequestKey(filter, appContext);
    const localizedKey = JSON.stringify([requestKey, lang]);
    const filterRef = useRef(filter);
    filterRef.current = filter;
    const appliedKeyRef = useRef<string>();

    useEffect(() => {
        if (disabled) {
            setIsLoading((prev) => (prev ? false : prev));
            return;
        }

        if (appliedKeyRef.current === localizedKey) {
            setIsLoading((prev) => (prev ? false : prev));
            return;
        }

        let cancelled = false;
        let rafId = 0;

        const apply = (entry: CacheEntry) => {
            if (cancelled) return;
            // Defer heavy toLang off the hover/mousemove frame
            rafId = window.requestAnimationFrame(() => {
                if (cancelled) return;
                setData(getTranslated(entry, lang));
                appliedKeyRef.current = localizedKey;
                setError(undefined);
                setIsLoading(false);
            });
        };

        const cached = tagsTreeCache.get(requestKey);
        if (cached) {
            apply(cached);
            return () => {
                cancelled = true;
                window.cancelAnimationFrame(rafId);
            };
        }

        setIsLoading(true);
        setError(undefined);

        fetchTagsTree(filterRef.current, appContext)
            .then(() => {
                if (cancelled) return;
                const entry = tagsTreeCache.get(requestKey);
                if (!entry) return;
                apply(entry);
            })
            .catch((reason) => {
                if (cancelled) return;
                setError(reason);
                setIsLoading(false);
            });

        return () => {
            cancelled = true;
            window.cancelAnimationFrame(rafId);
        };
    }, [disabled, requestKey, appContext, lang, localizedKey]);

    return [data, isLoading, error];
};
